import React from "react";
import { Box, Typography } from "@mui/material";
import CreatableSelect from "react-select/creatable";
import { FixedSizeList as List } from "react-window";
import { retrievalCreatableSelectStyles } from "./creatableSelectStyles";

export const customStyles = retrievalCreatableSelectStyles;

export const MenuList = (props) => {
  const height = 35;
  const { options, children, maxHeight } = props;

  return (
    <List
      height={Math.min(maxHeight, options.length * height)}
      itemCount={children.length}
      itemSize={height}
    >
      {({ index, style }) => <div style={style}>{children[index]}</div>}
    </List>
  );
};

export const LabeledCreatableSelect = ({
  label,
  options,
  value,
  onChange,
  placeholder,
  disabled,
  isDisabled,
}) => {
  const selectDisabled = disabled ?? isDisabled;
  return (
    <Box sx={{ marginBottom: "2px" }}>
      <Typography
        sx={{
          fontSize: "12px",
          color: "rgba(0, 0, 0, 0.6)",
          marginBottom: "4px",
          fontWeight: 500,
        }}
      >
        {label}
      </Typography>
      <CreatableSelect
        isClearable
        options={options}
        components={{ MenuList }}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        styles={customStyles}
        isDisabled={selectDisabled}
      />
    </Box>
  );
};
